import { CardNumberElement, Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import React, { createContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { ApiResult } from '../api';
import { shared } from '../config';

export const createPaymentToken = async ({ stripe, elements }) =>
  ApiResult.callAsync(async () => {
    if (!stripe || !elements) {
      throw new Error('stripe or elements has not yet loaded');
    }
    const cardElement = elements.getElement(CardNumberElement);
    const { token, error } = await stripe.createToken(cardElement);
    if (error) {
      throw error;
    }
    return token;
  });

const ELEMENTS_OPTIONS = {
  fonts: [
    {
      // Local fonts will not load properly without https in development
      // src URLs need to start with 'https://' or 'data:'
      family: 'Founders Grotesk',
      src: `url(/fonts/founders-grotesk-web-regular.woff2) format('woff')`,
    },
  ],
};
const stripePromise = loadStripe(shared.STRIPE_PUBLISHABLE_KEY);

const initialContext = {};
export const StripeContext = createContext(initialContext);

export const StripeElementsProvider = ({ children }) => {
  const [stripeLoaded, setStripeLoaded] = useState(true);

  useEffect(() => {
    stripePromise.then(
      () => setStripeLoaded(true),
      () => setStripeLoaded(false),
    );
  }, []);

  return (
    <StripeContext.Provider value={{ stripeLoaded }}>
      <Elements stripe={stripePromise} options={ELEMENTS_OPTIONS}>
        {children}
      </Elements>
    </StripeContext.Provider>
  );
};

StripeElementsProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
